import React, { useState, useRef } from "react";
import { createForm, readFile } from "./fileReader";
import LoadingRing from "./LoadingRing";
import { plusIcon, userIcon } from "../../../../../Base/SVG";
const fetchingStates = {
  idle: "STATE_IDLE",
  error: "STATE_ERROR",
  fetching: "STATE_FETCHING",
  success: "STATE_SUCCESS",
};

const ChooseImage = ({ addClass = "", active, imageData, updateForm }) => {
  const fileRef = useRef();
  const [status, setStatus] = useState(fetchingStates.idle);

  const previewImage = () => {
    if (fileRef.current.files && fileRef.current.files[0]) {
      readFile({
        file: fileRef.current.files[0],
        onStart: () => setStatus(fetchingStates.fetching),
        onLoad: (result) => onLoad(result),
        onLoadend: () =>
          setTimeout(() => setStatus(fetchingStates.success), 2000),
      });
    }
  };
  const onLoad = (resultImage) => {
    updateForm({
      avatar: resultImage,
    });
  };

  const deleteFunc = () => {
    updateForm({ avatar: "" });
    setStatus(fetchingStates.idle);
  };

  return (
    <div className={`upload ${active ? "active" : ""}`}>
      <div className="avatar">
        {status === fetchingStates.fetching ? (
          <LoadingRing size={20} color={"#ff9b63"} />
        ) : imageData ? (
          <img src={imageData} alt=" image" />
        ) : (
          <span className="icon">{userIcon}</span>
        )}
      </div>
      <div className="upload__btns">
        <button className="button primary">
          <input
            type="file"
            onChange={previewImage}
            ref={fileRef}
            accept="image/*"
          />
          {plusIcon}
          Upload new picture
        </button>
        {imageData && (
          <button className="button bordered" onClick={deleteFunc}>
            Remove
          </button>
        )}
      </div>
    </div>
  );
};

export default ChooseImage;
